const initHeadingVideo = () => {
    const video = document.querySelector("[data-heading-video]");
    if (video) {
        const container = video.closest("[data-slide]");
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://player.vimeo.com/api/player.js`;
        document.head.appendChild(script);
        if (container) {
            video.addEventListener('load', () => {
                container.style.background = "transparent";
            }, true);
        }
    }
};
